<template>
  <div class="container">
    <div class="header-bottom">
      <nav class="navbar navbar-light header-sticky">
        <router-link class="navbar-brand" to="/">
          <img
            class="logo-light"
            src="../../assets/images/logo.svg"
            alt="Image"
          />
          <img
            class="logo-dark"
            src="../../assets/images/logo-white.svg"
            alt="Image"
          />
        </router-link>

        <div class="other-option">
          <router-link to="/" class="btn style1"> Back To Home </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavbarTwo",
};
</script>

<style lang="scss" scoped>
.navbar-toggler {
  border: none;
  padding: 7px;
  border-radius: 0;

  .icon-bar {
    width: 28px;
    transition: all 0.3s;
    background: var(--clr_redical);
    height: 2px;
    display: block;
  }
  .top-bar {
    transform: rotate(0);
    left: 0;
  }
  .middle-bar {
    opacity: 1;
    margin: 6px 0;
  }
  .bottom-bar {
    transform: rotate(0);
    left: 0;
  }
  &[aria-expanded="true"] {
    .top-bar {
      transform: rotate(45deg);
      transform-origin: 10% 10%;
      left: 4px;
      position: relative;
    }
    .middle-bar {
      opacity: 0;
      margin: 6px 0;
    }
    .bottom-bar {
      transform: rotate(-45deg);
      transform-origin: 10% 90%;
      left: 4px;
      position: relative;
    }
  }
}
</style>